export default "__VITE_ASSET__Su6qxN$Y__"